module.exports = __webpack_public_path__ + "img/move14.795ef860.jpg";